<template>
  <div class="product-catalog">
    <h1 class="product-catalog__title">
      {{ _T("@Search results") }}: {{ filterStore.params.searchQuery }}
    </h1>
  </div>
  <ProductCatalog
    v-if="products?.length > 0"
    :products="products"
    :total-items="totalItems"
    :is-pending="isPending"
    :category-slider="categorySlider"
  />
  <EmptySearchResult v-else />
</template>

<script setup>
import ProductCatalog from "~/modules/productCatalog/ui/components/ProductCatalog.vue";
import EmptySearchResult from "~/modules/productCatalog/ui/pages/search/EmptySearchResult.vue";
import { useProductStore } from "~/store/productStore";
import { useProductFilterStore } from "~/store/productFilter.store.js";

const props = defineProps({
  isPending: { type: Boolean, required: true },
  categorySlider: { type: Array, required: true },
});

const filterStore = useProductFilterStore();
const productStore = useProductStore();
const { products, totalItems } = storeToRefs(productStore);

useSeoMeta({
  title: () =>
    `${_T("@Trademark")} - ${_T("@Search results")}: "${filterStore.params.searchQuery}"`,
});
</script>

<style scoped lang="scss"></style>
